// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__woiwW","ErrorMessage":"Checkbox_ErrorMessage__qnBEB"};